<template>
  <v-container fluid fill-height>
    <v-row class="d-flex">
      <v-col class="align-self-center">
        <v-sheet max-width="374" class="mx-auto">
          <v-card-text v-if="reset_password">
            <ForgotPassword @forgotPassword="forgotPassword"></ForgotPassword>
          </v-card-text>
          <v-card-text v-else>
            <v-form>
              <v-row dense>
                <v-col cols="12">
                  <v-text-field
                    v-model="form.username"
                    :disabled="loading"
                    autocomplete="username"
                    color="black"
                    prepend-inner-icon="mdi-account"
                    dense
                    outlined
                    required
                    hide-details
                    autofocus
                    @keypress.enter="login()"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="form.password"
                    :disabled="loading"
                    autocomplete="current-password"
                    color="black"
                    prepend-inner-icon="mdi-key"
                    type="password"
                    dense
                    outlined
                    required
                    hide-details
                    @keypress.enter="login()"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="d-flex justify-center align-center">
                  <span class="fgt-pw" @click="forgotPassword"
                    >Forgot your password?</span
                  >
                </v-col>
                <v-col cols="12" class="d-flex justify-center align-center">
                  <v-btn
                    :disabled="!form.username || !form.password"
                    :loading="loading"
                    color="primary"
                    @click="login()"
                  >
                    Login
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import swal from "sweetalert2";
import ForgotPassword from "@/views/ForgotPassword.vue";
export default {
  components:{ForgotPassword},
  data: () => ({
    form: {
      username: null,
      password: null,
      new_password:'',
      confirm_new_password:''
    },
    account_info: {},
    loading: false,
    reset_password: false,
    
  }),
  methods: {
    login() {
      if (this.form.username && this.form.password) {
        this.loading = true;

        this.$store
          .dispatch("login", this.form)
          .then((response) => {
            this.loading = false;
            this.$router.push("/home");
          })
          .catch((error) => {
            console.log(error);
            swal.fire({
              title: "Error!",
              text: error.response.data.error,
              icon: "error",
            });

            this.form.password = null;
            this.loading = false;
          });
      }
    },
    forgotPassword(evt) {
      this.reset_password = evt
    },
    
  },
};
</script>
<style scoped>
.centered-input >>> input {
  text-align: center;
}
.fgt-pw:hover {
  color: #666666;
  cursor: pointer;
}
</style>